module.exports = __webpack_public_path__ + "img/text-box-plus-outline.f5482a72.svg";